import enviro from 'enviro';

// Do not remove this.
// Marketing Ops relies on this for Intellimize/webflow personalization
// container to be loaded on all links that are owned by 53
const HUBSPOT_INTERNAL_PORTAL = 53;
export default function (portalId) {
  const key = 'webflow';
  if (portalId === HUBSPOT_INTERNAL_PORTAL && enviro.deployed(key) && enviro.getInternal(key) === 'prod' && !document.getElementById('hubspot-webflow-container')) {
    var _firstScript$parentNo, _firstScript$parentNo2, _firstScript$parentNo3;
    const firstScript = document.getElementsByTagName('script')[0];
    const head = document.head;
    const style = document.createElement('style');
    style.textContent = '.anti-flicker, .anti-flicker * {visibility: hidden !important; opacity: 0 !important;}';
    head.appendChild(style);
    const preconnects = [{
      href: 'https://api.intellimize.co',
      crossorigin: true
    }, {
      href: 'https://117964275.intellimizeio.com',
      crossorigin: false
    }, {
      href: 'https://log.intellimize.co',
      crossorigin: true
    }];
    preconnects.forEach(({
      href,
      crossorigin
    }) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossorigin) {
        link.crossOrigin = '';
      }
      head.appendChild(link);
    });
    const trackingScript = document.createElement('script');
    trackingScript.textContent = 'localStorage.setItem("intellimize_tracking_policy", "disabled");';
    (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.insertBefore(trackingScript, firstScript);
    const antiFlickerScript = document.createElement('script');
    antiFlickerScript.textContent = `(function(e,t,p){var n=document.documentElement,s={p:[],r:[]},u={p:s.p,r:s.r,push:function(e){s.p.push(e)},ready:function(e){s.r.push(e)}};e.intellimize=u,n.className+=" "+p,setTimeout(function(){n.className=n.className.replace(RegExp(" ?"+p),"")},t)})(window, 4000, 'anti-flicker')`;
    (_firstScript$parentNo2 = firstScript.parentNode) === null || _firstScript$parentNo2 === void 0 || _firstScript$parentNo2.insertBefore(antiFlickerScript, firstScript);
    const tag = document.createElement('script');
    tag.id = 'hubspot-webflow-container';
    tag.async = true;
    tag.src = 'https://cdn.intellimize.co/snippet/117964275.js';
    tag.onerror = () => {
      document.documentElement.className = document.documentElement.className.replace(/ ?anti-flicker/, '');
    };
    (_firstScript$parentNo3 = firstScript.parentNode) === null || _firstScript$parentNo3 === void 0 || _firstScript$parentNo3.insertBefore(tag, firstScript);
  }
}